/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Targetageto2Inputs */

const en_targetageto2 = /** @type {(inputs: Targetageto2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To`)
};

const de_targetageto2 = /** @type {(inputs: Targetageto2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bis`)
};

/**
* | output |
* | --- |
* | "To" |
*
* @param {Targetageto2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const targetageto2 = /** @type {((inputs?: Targetageto2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Targetageto2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_targetageto2(inputs)
	return de_targetageto2(inputs)
});
export { targetageto2 as "targetAgeTo" }